import { styled } from '@mui/material/styles';
import { breakpoints } from '../../theme';

export const HomeWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    align-items: center;
    width: 100%;
  }
`;
